import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'src/app/Services/Event/event.service';
import { ToastService } from 'src/app/Services/toast/toast.service';
@Component({
  selector: 'app-updateevent',
  templateUrl: './updateevent.component.html',
  styleUrls: ['./updateevent.component.scss'],
})
export class UpdateeventComponent implements OnInit {
  event: any;
  id: any;
  style1: string;
  isOpened: boolean;
  toggleStyle: string;
  msg = '';
  showmsg = true;
  selectedFile: File = null;
  constructor(
    private act: ActivatedRoute,
    private _shared: EventService,
    private router: Router,
    private toast: ToastService
  ) {}

  toggle() {
    this.style1 = 'flex';
    // this.style2="none";
    this.isOpened = true;
    this.toggleStyle = 'flex';
  }
  closeNote() {
    this.style1 = 'none';
    this.isOpened = false;
  }
  ngOnInit(): void {
    this.id = this.act.snapshot.paramMap.get('id');
    this._shared.getEventById(this.id).subscribe(
      (res) => {
        this.event = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  update() {
    this._shared.updateEvent(this.id, this.event).subscribe((res) => {
      console.log(res);
      this.isOpened = true;
      this.toast.SuccessToast('Event updated with succes !');
      this.showmsg = false;
      this.router.navigate(['/home/events']);
    },err=>{
      console.log(err);
    }
      
    )
  }

  onFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
    console.log(this.selectedFile);
  }
}
